import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'promptuary-filling-instructions-warning',
	templateUrl: './promptuary-filling-instructions-warning.component.html',
	styleUrls: ['./promptuary-filling-instructions-warning.component.scss'],
})
export class PromptuaryFillingInstructionsWarning {
	constructor(public translateService: TranslateService) {}

	openQualityPage() {
		window.open(
			this.translateService.instant('PROMPTUARY.QUALITY_MODAL.MORE_ABOUT.LINK'),
			'_blank'
		);
	}
}
